export * from './AddonProductInfo';

export const chewsInformationalCopy = {
  header: 'Are Chews right for my dog?',
  body: `Dogs of all ages and breeds can enjoy Chews! Best for experienced chewers. For beginners, consider use of a chew holder.
  As with any chew, always supervise use. Dogs with fragile or missing teeth may prefer a softer option.`,
};
